export const skillsData = [
    'Java',
    'Python',
    'HTML',
    'Node JS',
    'Figma',
    'Javascript',
    'CSS',
    'React',
    'Angular',
    'Bootstrap',
    'MongoDB',
    'Tailwind',
    'MySQL',
    'MaterialUI',
    'Django',
    'AWS',
    'Next JS',
    'Git',
    'Numpy',
    'Pandas',
    'Docker',
    'Typescript',
    'ViteJS',
    'Data Analytics'
];
